module.exports = __webpack_public_path__ + "img/1482648312.558e57ea.jpg";